import { render, staticRenderFns } from "./PsBackButton.vue?vue&type=template&id=7a7230ae&scoped=true&"
import script from "./PsBackButton.vue?vue&type=script&lang=js&"
export * from "./PsBackButton.vue?vue&type=script&lang=js&"
import style0 from "./PsBackButton.vue?vue&type=style&index=0&id=7a7230ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a7230ae",
  null
  
)

export default component.exports